export default __webpack_public_path__ + "public/assets/images/8122e529302ae63aebfcac8afa56a750.png";